import { Component, Input, OnInit, SimpleChanges, OnChanges } from '@angular/core'
import { FormSearchComponent } from '../../../../shared/components/form-search/form-search.component'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../../shared/components/table-list/table-list.component'
import { AuthService } from '../../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../../core/models/contact-type.model'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { ConsultantService } from '../../../../core/services/person/consultant/consultant.service'
import { VehicleService } from '../../../../core/services/vehicle/vehicle/vehicle.service'
import { VehicleEditComponent } from '../../../../features/vehicle/vehicle-register/vehicle-edit/vehicle-edit.component'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'

@Component({  
  selector: 'vehicle-tg',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    FormClientSearchComponent,
  ],
  templateUrl: './vehicle-tg.component.html',
  styleUrl: './vehicle-tg.component.scss',
  standalone: true,
  providers: [ConsultantService, AuthService],
})
export class VehicleTgComponent implements OnInit, OnChanges {
  constructor(
    private consultantService: ConsultantService,
    private authService: AuthService,
    private dialog: MatDialog,
    private vehicleService: VehicleService,
    private snackbar: SnackbarCustomService
  ) { }

  @Input() listRefresh: any

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch = ''
  columns: any[] = [
    // { keyColumn: 'code', key: 'id', description: 'Código' },
    // {
    //   keyColumn: 'supplier',
    //   key: 'razaoSocial',
    //   description: 'Fornecedor',
    // },
    {
      keyColumn: 'typeVehicle',
      key: 'descricaoTipoVeiculo',
      description: 'Tipo Veiculo',
    },
    {
      keyColumn: 'model',
      key: 'modelo',
      description: 'Modelo',
    },
    {
      keyColumn: 'fleet',
      key: 'placa',
      description: 'Placa',
    },
    // {
    //   keyColumn: 'cnpj',
    //   key: 'cnpj',
    //   description: 'Cnpj',
    // },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  screen = 'status operação'

  inputSearchClient: any = { type: '', search: '' }
  listSearch: any = [
    { id: 'nome', description: 'Nome' },
    { id: 'email', description: 'Email' },
    { id: 'nascimento', description: 'Nascimento' },
    { id: 'telefone', description: 'Telefone' },
  ]

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['listRefresh'] && changes['listRefresh'].currentValue) {   
      this.getListItems();
    }
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        // delete: this.checkPermission('deletar'),
        delete: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    const search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.vehicleService.searchPagedVehicleFrotModel(this.page, this.rows).subscribe({
      next: (response: any) => {
        this.treatResponse(response)
        
      },
      error: (err: PagedContactTypeResponse) => { },
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.consultantService
      .searchPagedConsultant(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => { },
        complete: () => {
          this.loading = false
        },
      })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(VehicleEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { item, frota: true },
    })
    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.uploadList()
        this.getListItems()
      }
    })
  }

  deleteItem(item: any) {
    this.vehicleService.deleteVehicle(item.id).subscribe({
      next: (response: any) => {
        this.snackbar.success('Deletado com Sucesso')
        this.uploadList()
        this.getListItems()
      },
      error: (err: PagedContactTypeResponse) => { },
      complete: () => { },
      
    })
  }

}
